import React, { useState, useEffect } from "react";
import "./styles/Home.css";
import { useInView } from "react-intersection-observer";
import { useNavigate } from "react-router";
import GooglePlayBadge from "../assets/GetItOnGooglePlay_Badge_Web_color_English.svg";
import AppStoreBadge from "../assets/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg";

const Home = ({ handleScroll }) => {
  // Intersect Observer ( Checks if component is in view )
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });

  let navigate = useNavigate();


  const today = new Date();
  const cutoffDate = new Date('2025-08-03T00:00:00'); // exclusive: 2 Aug 23:59:59

  const showRunyourbody = today < cutoffDate;

  return (
    <div className="home">
      <div className="content">
        <div className="left">
          <h1 style={{ transform: "translateX(0px)" }}>Connection</h1>
          <h1 style={{ transform: "translateX(0px)", fontSize: "45px" }}>
            through
          </h1>
          <h1 style={{ transform: "translateX(0px)" }}>Movement</h1>
          {/* <p style={{ color: "var(--color-primary)", margin: '0' }}>{"A platform designed to bring people together "} </p>
          <p style={{ color: "var(--color-primary)", margin: '0', marginBottom: '12px' }}>{" and form connection through movement"} </p> */}
          <p
            style={{
              color: "var(--color-primary)",
              margin: "15px 0px",
              fontSize: "21px",
              fontWeight: 600,
              textAlign: "center",
            }}
            className="paragraph"
          >
            {
              "A platform designed to bring people together. From trail runs to underwater long jump, connection starts here."
            }
          </p>
          <button onClick={() => handleScroll("events")} className="cta-button">
            Start Moving
          </button>
          <button onClick={() => navigate("/connect")} className="cta-button-secondary">
            Explore Newro Connect
          </button>
        </div>
        <div className="right">
          <div className="store-badges">
            <a href="https://play.google.com/store/apps/details?id=com.alberfmlouw.newro" target="_blank" rel="noopener noreferrer">
              <img src={GooglePlayBadge} alt="Get it on Google Play" />
            </a>
            <a href="https://apps.apple.com/za/app/newro/id6758213980" target="_blank" rel="noopener noreferrer">
              <img src={AppStoreBadge} alt="Download on the App Store" />
            </a>
          </div>
        </div>
      </div>
      {/* <Wave position={"bottom"} /> */}
    </div>
  );
};

export default Home;
